export const axiosClient = Symbol("axiosClient");
